import {Action, combineReducers} from "redux";
import {isType} from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/ClientManager";
import {loadingReducer} from "src/utils/reducers";

import {
  getProjects, projectsRoute, createProjectClicked, newProjectNameChanged,
  cancelCreateClicked, createProject,
} from "./Projects.actions";


const projects = (state: Ganymede.Project[] | null = null,
                  action: Action): Ganymede.Project[] | null => {
  if (isType(action, getProjects.done))
    return action.payload.result;

  if (isType(action, projectsRoute.leaved))
    return null;

  if (state != null && isType(action, createProject.done)) {
    return [...state, action.payload.result];
  }

  return state;
};

const createDialogOpen = (state: boolean = false, action: Action): boolean => {
  if (isType(action, createProjectClicked))
    return true;

  if (isType(action, cancelCreateClicked))
    return false;

  if (isType(action, createProject.done))
    return false;

  return state;
};

const createError = (state: Object | null = null,
                     action: Action): Object | null => {
  if (isType(action, createProject.failed))
    return action.payload.error;

  if (isType(action, createProject.done))
    return null;

  if (isType(action, cancelCreateClicked))
    return null;

  return state;
};

const newProjectName = (state: string = '', action: Action): string => {
  if (isType(action, newProjectNameChanged))
    return action.payload;

  if (isType(action, cancelCreateClicked))
    return '';

  if (isType(action, createProject.done))
    return '';

  return state;
};

const isCreating = loadingReducer(createProject);

export interface ProjectsState {
  projects: Ganymede.Project[] | null;
  createDialogOpen: boolean;
  newProjectName: string;
  isCreating: boolean;
  createError: Object | null;
}

export default combineReducers({
  projects,
  createDialogOpen,
  newProjectName,
  isCreating,
  createError,
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/reducer.ts